export const allowedImages = ['.jpg', '.jpeg', '.png', '.gif', '.webp']
export const allowedVideos = ['.mov', '.avi', '.mkv', '.wmv', '.flv', '.mp4', '.webm']
export const allowedAudios = ['.mp3', '.wave', '.ogg', '.wav']